import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Button, Form, Input, InputNumber, Select, TextArea, TimePicker } from 'components/shared/FormComponent';
import { Empty, Switch, Table, TableProps, Tooltip, Popconfirm, Skeleton, Modal, } from 'components/shared/AntComponent';
import { ArrowLeftOutlined, DeleteFilled, DownCircleFilled, DownSquareOutlined } from 'components/shared/AntIcons';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';
import { getCourse, getPublicCourse, getSpecialisation } from 'services/store/actions/masterDataAction';
import AddSlotScreen from 'components/exam/sub-screens/AddSlotScreen';
import { EditIcon, EyeIcon } from 'assets/icons/CustomIcons';
import { getExamDetail } from 'services/store/actions/examAction';
import AssociateApplicant from './AssociateApplicant';
import { getQuestionPaperDetail } from 'services/store/actions/questionPaperAction';

interface ChildProps {
    slots: any;
    duration: any;
    // rowData: any;
    isPastDate: boolean;
    tempOptions: any;
    college: any;
    examName: string;
    totalMark: any;
    currentStep: number;
    examUniqueId:any;
}

const CreateSlot: React.FC<ChildProps> = ({ currentStep, slots, duration, totalMark, college, tempOptions, examName, isPastDate,examUniqueId }) => {
    const { success1, loading1, error1, examDetailInfo, loading4, deptQuesInfo, loading12, loading15: autoLoading, autoQuesInfo, loading16, newAutoQuesInfo,
        loading13, success13, error13, addexamData
    } = useSelector((state: any) => state.exam);
    const dispatch = useDispatch();
    const { questionpaperData, loading: loadingQuestions, loading11, templateInfo, paperInfo, loading4: paperLoading } = useSelector((state: any) => state.questionpaper);
    const [showAdd, setShowAdd] = useState(false);
    const [title, setTitle] = useState("");
    const [expandVal, setExpandVal]: any = useState([]);
    const [slot, setSlot]: any = useState(slots);
    const [currentSlot, setCurrentSlot]: any = useState(null);
    const [slotIndex, setSlotIndex]: any = useState(null);
    const [rowData, setRowData]: any = useState(null);
    const [tempOpt, setTempOpt]: any = useState([]);
    const [quesData, setQuesData]: any = useState(null);
    const templateOptions = !loading11 && templateInfo?.data?.map((item: any) => {
        return {
            value: item?.quesTemplateID,
            label: item?.quesTemplateName
        }
    }) || [];
    const [quesModal, setQuesModal] = useState(false);
    const getquesPaper = (id: any) => {
        const ids = id + "/" + Number(localStorage.getItem('tenantID'));
        dispatch(getQuestionPaperDetail(ids) as any);
    };
    useEffect(() => {
        if (paperInfo?.data) {
            const value = paperInfo?.data?.[0]?.qpQuestions;
            setQuesData(value);
        }
    }, [paperInfo?.data]);

    const handleShowSlot = () => {
        setShowAdd(true);
        setSlotIndex(null);
    }
    const closeSlot = () => {
        setShowAdd(false);
    }
    const handleEdit = (val: any, index: number) => {

        setRowData(val);
        setTitle("Question Paper");

        setSlotIndex(index);
        // const temp = form.getFieldValue('questionTemplate');
        // const opt = templateOptions?.filter((item: any) => temp?.includes(item.value))?.map((item: any) => ({
        //     value: item.value,
        //     label: item.label
        // })) || [];
        // setTempOpt(opt);
        setShowAdd(true);
    }

    const handleEdit1 = (val: any, index: number) => {
        setRowData(val);
        setTitle("Associate Applicant");
        setSlotIndex(index);
        setShowAdd(true);
    }
    const getDetail = (ids: any) => {
        const id = ids + "/" + Number(localStorage.getItem('tenantID'));
        dispatch(getExamDetail(id) as any);
    };
    const loadData1 = () => {
        if (examDetailInfo?.data && addexamData?.data !== 0) {
            const defaultValue = examDetailInfo?.data?.[0];

            const slotJson = defaultValue?.examSlots?.map((value: any) => ({
                ExamSlotId: value?.examSlotId || 0,
                ExamID: defaultValue?.examID || 0,
                ExamName: defaultValue?.examName || "",
                ExamSlotName: value.examSlotName || "",
                ExamStartTime: value.examStartTime || null,
                ExamEndTime: value.examEndTime || null,
                ExamDuration: defaultValue?.examDuration || null,
                TotalMark: defaultValue?.totalMarks || 100,
                IsAssoCondition: value.isAssoCondition || "",
                ConditionIDs: value.isAssoCondition === "gender" ? value?.conditionIDs?.split(',') : value?.conditionIDs?.split(',')?.map(Number) || "",
                ConditionName: value.isAssoCondition === "gender" ? value?.conditionName?.split(',') : value?.conditionName?.split(',') || "",
                TotalCapacity: value.totalCapacity || "",
                Status: value.status || "active",
                TenantId: Number(localStorage.getItem('tenantID')),
                AccountId: Number(defaultValue?.accountId) || null,
                QuestionPaper: {
                    QuesPaperID: value?.questionPaper?.quesPaperID || 0,
                    QuesPaperName: value?.questionPaper?.quesPaperName || "",
                    QuesGenMode: "Auto",
                    ExamID: defaultValue?.examID || 0,
                    ExamName: defaultValue?.examName || "",
                    SlotID: value?.examSlotId || 0,
                    SlotName: value.examSlotName || "",
                    NoOfQuestions: defaultValue?.totalMarks,
                    TotalMarks: defaultValue?.totalMarks,
                    Notes: value?.questionPaper?.notes || "",
                    TenantId: Number(localStorage.getItem('tenantID')),
                    EasyPercent: value?.questionPaper?.easyPercent,
                    MediumPercent: value?.questionPaper?.mediumPercent,
                    HardPercent: value?.questionPaper?.hardPercent,
                    IsCombinedTemplate: true,
                    Status: "Active",
                    QpSections: value?.questionPaper?.qpSections?.map((item: any) => ({
                        QpSectionID: item?.qpSectionID || 0,
                        QuesPaperID: item?.quesPaperID || 0,
                        QpSectionName: item.qpSectionName || "",
                        IsAssoCondition: item.isAssoCondition || "",
                        ConditionName: item.conditionName?.toString() || "",
                        QuesTemplateID: item.quesTemplateID?.toString() || "",
                        QuesTemplateName: item.quesTemplateName || "",
                        TenantId: Number(localStorage.getItem('tenantID')),
                    })) || null
                }
            }))
            setSlot(slotJson);
            const temp = defaultValue?.quesTemplateID?.split(',')?.map(Number) || [];
            const opt = templateOptions?.filter((item: any) => temp?.includes(item.value))?.map((item: any) => ({
                value: item.value,
                label: item.label
            })) || [];
            setTempOpt(opt);
        }
        // setIsLoaded(true);
    }

    useEffect(() => {
        if (examDetailInfo?.data && currentStep == 1) {
            loadData1();
        }
    }, [examDetailInfo?.data]);

    const callbackFunc = (item: any) => {
        if (rowData) {
            //update row based on slotIndex variable
            setSlot((prevSlots: any) =>
                prevSlots.map((slot: any, idx: number) =>
                    idx === slotIndex ? item : slot
                )
            );
        } else {
            setSlot((prevSlots: any) => [...prevSlots, item]);
        }

        closeSlot();
        getDetail(examDetailInfo?.data?.[0]?.examID);
    }

    const callbackFunc1 = () => {
        closeSlot();
    }
    const handleOpenQuesModal = (id: any) => {
        setQuesModal(true);
        getquesPaper(id);
        setQuesData(null);
    }
    const handleCloseQuesModal = () => {
        setQuesModal(false);
    }
    const handleExpand = (id: string) => {
        let myArray = expandVal;
        const valueExists = myArray.includes(id);
        if (!valueExists) {
            myArray = [...myArray, id];
        } else {
            if (myArray.includes(id)) {
                myArray = expandVal.filter((item: any) => item != id);
            }
        }
        setExpandVal(myArray);
    };
    return (
        <div className='p-2'>
            <div className="d-flex py-2 page-header">
                <h6 className="fw-bold my-auto">{showAdd ? rowData ? title : "Create Slot" : "Slot Details"}
                    <small className='text-danger ps-2 fw-normal'>* Generate the question paper and associate candidate(s) to activate the exam.</small>
                </h6>
                <div className="col-md-7 ms-auto text-end">

                    {showAdd ? <div>
                        <Button type="primary" className="col-auto rounded-circle fs-20" icon={<ArrowLeftOutlined className='fs-20 fw-bold' />} onClick={closeSlot}></Button>
                    </div> :
                        ""}
                </div>
            </div>
            {showAdd && title == "Question Paper" ? <AddSlotScreen
                totalMark={totalMark}
                isPastDate={isPastDate} rowData={rowData}
                slots={slot} duration={duration} tempOptions={tempOpt}
                college={college} examName={examName}
                callbackFunc={callbackFunc} />
                : showAdd && title == "Associate Applicant" ? <AssociateApplicant callbackFunc1={callbackFunc1} slots={slot} duration={duration} rowData={rowData} examUniqueId={examUniqueId}/> : <>{slot?.length == 0 ?
                    <div className="bg-light p-5 mb-3 text-muted text-center col-md-12">
                        No slot associated
                    </div> : <div>

                        {slot?.map((item: any, index: number) => {
                            const count = Number(index) + 1;
                            return (
                                <div key={index} className="mb-3 bg-light border p-3 w-100 ">
                                    <div className="d-flex flex-wrap">
                                        <div className='col-md-2'>
                                            <h6 className='fs-15 fw-bold'>Slot Name</h6>
                                            <span>{item.ExamSlotName || "--"}</span>
                                        </div>
                                        <div className='col-md-1'>
                                            <h6 className='fs-15 fw-bold'>Start Time</h6>
                                            <span>{item?.ExamStartTime ? item?.ExamStartTime : '--'}</span>
                                        </div>
                                        <div className='col-md-1'>
                                            <h6 className='fs-15 fw-bold'>End Time</h6>
                                            <span>{item?.ExamEndTime ? item?.ExamEndTime : '--'}</span>
                                        </div>
                                        <div className='col-md-1'>
                                            <h6 className='fs-15 fw-bold'>Capacity</h6>
                                            <span>{item?.TotalCapacity || '--'}</span>
                                        </div>
                                        <div className='col-md-2 '>
                                            <h6 className='fs-15 fw-bold'>Status</h6>
                                            <span className={`${item.Status?.toLowerCase() == "active" ? 'text-success fw-bold' : !item.isActive ? 'text-danger fw-bold' : 'text-dark'} text-capitalize`}>{item?.Status}</span>
                                        </div>
                                        <div className='col-md-2'>
                                            <h6 className="fs-15 fw-bold">Is Question paper associated?

                                            </h6>
                                            <span className={`${item.QuestionPaper?.QpSections?.length > 0 ? 'text-success fw-bold' : !item.isActive ? 'text-danger fw-bold' : 'text-dark'}`}>{item.QuestionPaper?.QpSections?.length > 0 ? "Yes" : "No"}</span>
                                        </div>
                                        <div className='col-md-2'>
                                            <h6 className="fs-15 fw-bold">View Question paper
                                                <div className="pt-1">{item.QuestionPaper?.QpSections?.length > 0 ? <span onClick={() => handleOpenQuesModal(item.QuestionPaper?.QuesPaperID)}><EyeIcon size={20} /> </span> : "--"}</div>
                                            </h6>
                                        </div>
                                        {isPastDate ? "" :
                                            <div className="col-auto ms-auto d-flex align-items-center ">
                                                <div className='d-flex'><Button type="primary" className='bg-blue me-2' onClick={() => handleEdit(item, index)}>Generate Question Paper</Button>
                                                    <Button type="primary" className='bg-warning me-2' onClick={() => handleEdit1(item, index)}>Associate Applicant</Button></div>
                                                {/* <div className="pointer pb-2" onClick={() => handleEdit(item, index)}><EditIcon size={30} /></div> */}
                                                <div className="pointer my-auto">
                                                    <Popconfirm
                                                        title="Delete Slot"
                                                        description="Are you sure to delete this slot?"
                                                        // onConfirm={() => {
                                                        //     handleRemoveSlot(index);

                                                        // }}
                                                        okText="Yes"
                                                        cancelText="No"
                                                    >
                                                        <span className="pt-2 fs-17">
                                                            <DeleteFilled className="text-danger pointer" />
                                                        </span>
                                                    </Popconfirm>
                                                </div>
                                            </div>}
                                    </div>

                                </div>
                            )
                        })}</div>}
                </>}
            <Modal title="View Questions" open={quesModal} confirmLoading={paperLoading} onCancel={handleCloseQuesModal} maskClosable={false} footer={null} width={1200}>
                <>
                    <div className="mb-3 p-2 bg-light question-list-cont-modal custom-scrollbar row mx-0 overflow-auto">
                        {paperLoading ? (
                            <Skeleton active />
                        ) : (
                            <>
                                {quesData?.map((item: any, index: number) => {
                                    // counter1++;
                                    return (
                                        <div key={index} className=" d-flex mb-3 col-md-6">
                                            {/* <Checkbox
                                                className="mb-auto"
                                                defaultChecked={selectedVal1?.includes(item.id)}
                                                checked={selectedVal1?.includes(item.id)}
                                                onChange={handleCheckedModal(item.id, item)}
                                            ></Checkbox> */}
                                            <div className="question-cntr border ms-2 w-100">
                                                <div className="bg-lightPrimary d-flex p-2 align-items-start">
                                                    <div>
                                                        <span className="text-secondary fw-bold pe-3">( {index + 1} )</span>
                                                        <span className="author-name fw-bold text-gray pe-4">{item.questionText}</span>{' '}
                                                        {/* {item?.question_image ? <Image src={window.origin + "/api" + item.question_image} height={50} /> : ""} */}
                                                        {/* <span className="text-dark">System Admin</span> */}
                                                        <div className="me-2">
                                                            <div className="bg-primary fs-12 text-white rounded px-2 me-2 py-1 col-auto d-inline-block my-2">
                                                                {item.subjectName}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <div className="ms-5 text-dark">
                                                    <span className=" fw-bold text-gray">Updated on: </span> <span className="text-dark">{date.format('DD-MM-YYYY HH:mm')}</span>
                                                </div> */}
                                                    <div className="ms-auto d-flex qus-opr">
                                                        <div className="pe-1 my-auto">
                                                            <DownCircleFilled
                                                                className={`${item.levelOfDifficulty?.toLowerCase() == 'easy' ? 'text-success bg-success' : item.levelOfDifficulty?.toLowerCase() == 'medium' ? 'text-warning bg-warning' : 'text-danger bg-danger'} rounded-circle`}
                                                            />
                                                        </div>
                                                        <div className="text-primary ms-1 mb-0 mt-1 pointer my-auto" onClick={() => handleExpand(item.questionId)}>
                                                            {expandVal?.includes(item.questionId) ? <DownSquareOutlined className="fs-17" rotate={-90} /> : <DownSquareOutlined className="fs-17" />}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`p-2 d-flex question-contn bg-white ${expandVal?.includes(item.questionId) ? 'incheight' : ''}`}>
                                                    <div className="ps-2 pe-4 w-100">
                                                        {/* <span className="question text-dark fs-16">{item.Mdquestions_name}</span> */}
                                                        <div className="row m-3">
                                                            {item.Mdquestions_type === "inputfield" || item.Mdquestions_type == "input" ? <div className="fw-bold fs-15">
                                                                <span className="text-success">
                                                                    {item.answer}
                                                                </span>
                                                            </div> : <>
                                                                {item.qpOptions?.map((opt: any, i: number) => {
                                                                    return (
                                                                        <div className={`col-md-6 d-flex ${i % 2 == 0 ? 'ps-0' : 'pe-0'}`} key={i}>
                                                                            <div className={`p-2 w-100 mb-2 fs-15 ${opt.answer_option ? 'text-success fw-bold' : 'text-gray '}`}>
                                                                                <span className={`option-name fw-bold ${opt.answer_option ? 'text-success' : 'text-gray '}`}>
                                                                                    {String.fromCharCode(i + 65)}
                                                                                </span>
                                                                                <span className="ms-2 option"> {opt?.option_image ? "" : opt.optionText}</span>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}</>}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </div>
                    {/* <div className="text-center">
                        <Pagination defaultCurrent={pageIndex} current={pageIndex} total={totalRecord} defaultPageSize={pageSize} pageSize={pageSize}
                            onChange={handleChangePagination}
                            onShowSizeChange={handlePageSizeChange} showTotal={(total) => `Total ${count} items`} />
                    </div> */}
                </>
            </Modal>
        </div>
    )
}

export default CreateSlot;